module.exports = __webpack_public_path__ + "img/img44.e52abf0e.png";